export default __webpack_public_path__ + "static/media/icon-robot-select.2abde689.webp";